import { Typography } from "@mui/material";
export default function Welcome(){
    return(
        <Typography>
            welcome!
        </Typography>
    );
}